import { z } from 'zod';
import { professionDisplaySettingsSchema } from './IProfessionDisplaySettings';

// Schemas (source of truth)
export const professionProjectPropertiesSchema = z.object({
	backgroundColor: z.string(),
	displaySettings: professionDisplaySettingsSchema.optional(),
});

// Types (derived from schemas)
export type IProfessionProjectProperties = z.infer<typeof professionProjectPropertiesSchema>;
